import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43051db7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-animation tw-relative tw-bg-white tw-rounded tw-border tw-border-1 tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]" }
const _hoisted_2 = {
  id: "dash-vendor-assessment-card-title",
  class: "tw-h-[66px] tw-rounded-t tw-flex tw-justify-between tw-items-center tw-bg-[#FCFCFD] tw-py-[25px] tw-px-[20px] tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_3 = { class: "tw-flex tw-gap-[10px]" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[18px] tw-font-semibold" }
const _hoisted_5 = { class: "vendor-ass-card-body tw-grid tw-grid-cols-1 tw-gap-[20px] tw-p-[25px]" }
const _hoisted_6 = {
  key: 0,
  class: "custom-global-skeleton tw-p-[20px] tw-h-[112px]"
}
const _hoisted_7 = {
  key: 0,
  class: "vendor-ass-card-body tw-grid tw-grid-cols-1 tw-gap-[20px] tw-p-[25px]"
}
const _hoisted_8 = {
  key: 0,
  class: "custom-global-skeleton tw-p-[20px] tw-h-[112px]"
}

import { computed, onMounted, PropType, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import DashboardVendorAssessmentCard from "./dashboardVendorAssessmentCard.vue";
import { IChecklistRequested } from "@/interfaces/vendor";
import store from "@/store";
import DummyCard from "./dummyCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'dashBoardVendorAssessment',
  emits: ["button:click"],
  setup(__props, { emit: emits }) {

const checklistDetailData = computed(
  () => store.state.Vendor.requestedChecklist,
);
const sortVendorAssessmentCard = ref<IChecklistRequested[]>([]);


const isLoading = ref(true);

watch(
  checklistDetailData,
  (newValue) => {
    sortVendorAssessmentCard.value = [...newValue].sort(
      (a, b) => (b.scorePcnt ?? 0) - (a.scorePcnt ?? 0),
    );
  },
  { immediate: true },
);

onMounted(async () => {
  isLoading.value = true;
  await store.dispatch("Vendor/fetchRequestedChecklist", {
    isArchived: false,
  });
  isLoading.value = false;
});

const fakeData = [
  {
    checklistRequestedId: 1,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.5,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
  {
    checklistRequestedId: 2,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.75,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
  {
    checklistRequestedId: 3,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.45,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
  {
    checklistRequestedId: 3,
    checklistRequestedHistory: [],
    providerName: "abc",
    scorePcnt: 0.35,
    status: "Completed",
    name: "test",
    dateUpdated: "12/12/2022",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-dashboard-vendor-assessment-title-1")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : _createCommentVNode("", true),
      (!isLoading.value && !sortVendorAssessmentCard.value.length)
        ? (_openBlock(), _createBlock(DummyCard, {
            key: 1,
            title: _unref(getComponentUiText)('app-dashboard-dummy-title-vendor-ass-1'),
            "title-button": 
          _unref(getComponentUiText)('app-dashboard-dummy-button-title-vendor-ass-1')
        ,
            "title-class": 'tw-w-[322px]',
            "custom-class": 'tw-top-[67px]',
            "onButton:click": _cache[0] || (_cache[0] = () => emits('button:click'))
          }, null, 8, ["title", "title-button"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortVendorAssessmentCard.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(DashboardVendorAssessmentCard, { data: item }, null, 8, ["data"])
        ]))
      }), 128))
    ]),
    (!isLoading.value && !sortVendorAssessmentCard.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("", true),
          (!isLoading.value && !sortVendorAssessmentCard.value.length)
            ? (_openBlock(), _createBlock(DummyCard, {
                key: 1,
                title: _unref(getComponentUiText)('app-dashboard-dummy-title-vendor-ass-1'),
                "title-button": 
          _unref(getComponentUiText)('app-dashboard-dummy-button-title-vendor-ass-1')
        ,
                "title-class": 'tw-w-[322px]',
                "custom-class": 'tw-top-[67px]',
                "onButton:click": _cache[1] || (_cache[1] = () => emits('button:click'))
              }, null, 8, ["title", "title-button"]))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fakeData, (item, index) => {
            return _createElementVNode("div", { key: index }, [
              _createVNode(DashboardVendorAssessmentCard, { data: item }, null, 8, ["data"])
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})